import React, { useEffect, useLayoutEffect, useReducer, useState } from "react";
import ReactDOM from "react-dom";
// import { logEvent } from "@Lib/analytics";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { fetchRecommendArticleChoice, fetchRecommendArticleRelated } from "@Services/api";
import cx from "classnames";
import styles from "./comparePageFeaturedRecommended.modules.less";
import HotVideo from "@Components/movie/HotVideo/index";
import EquipsSelect from "@Components/movie/Equips";
import { host } from "@Services/url";
import { article } from "@Api";
import { g4 } from "../../utils/helper";

const Content = () => {
  const getSpmUpdate = () => {
    const url = new URL(location.href);
    const spm = url.searchParams.get("spm");
    g4("browse", {
      page_name: "文章詳情頁",
      spm: spm || "",
      page_channel: "文章",
      sub_channel: "",
      page_business: "",
      module: "",
      version_number: "",
      bussiness: "",
      page: "",
      channel: "",
      user_id: "",
      page_type: "",
      element: "",
      element_id: "",
      relate_id: "",
      object_id: window.article.id,
      next_spm: "",
      brand_id: "",
    });
  };

  useEffect(() => {
    const delay = 2000;
    const timer = setTimeout(() => {
      // getSpmUpdate();
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return <></>;
};

const $app = document.getElementById("common-articles-browse");
!!$app && ReactDOM.render(<Content />, $app);
